/*
 *  Copyright (c) 2020 Cognitran Limited. All Rights Reserved.
 */

var locked = false;
$(".document-favourite").on('click', function (e) {
    e.preventDefault();
    if (!locked) {
        locked = true;
        var $link = $(this),
            documentId = $link.data('documentId'),
            currentFavouriteState = $link.hasClass('favourite-star-checked'),
            newFavouriteState = !currentFavouriteState;
        $.ajax({
            url: $i.contextPath + "/service/document/favourite",
            type: 'POST',
            data: {documentId: documentId, favourite: newFavouriteState},
            timeout: 5000
        }).done(function () {
            $link.toggleClass('favourite-star-checked', newFavouriteState);
            $link.toggleClass('favourite-star-unchecked', !newFavouriteState);
            $link.attr('title', newFavouriteState ? $i.i18n.get('user.document.remove-favourite') : $i.i18n.get('user.document.favourite'));
        }).fail(function () {
            $i.dialog({
                bodyKey: 'user.document.favourite.error',
                modal: true,
                buttonKeys: {
                    'button.ok': function () {
                        this.destroy();
                    }
                }
            });
        }).always(function () {
            locked = false;
        });
    }
});
